<template>
  <div class="page">
    <project-page-header ref="pageHeader" show-steps show-tabs show-stat :id="projectId">
      <template v-slot:actions="{ data }">
        <a-space>
          <template v-if="data.state === 7">
            <a-button size="small" icon="form" type="indigo" v-if="data.budgetState == 0" @click="$router.push(`../budget?id=${projectId}`)">提交项目预算表</a-button>
            <a-button size="small" icon="form" type="indigo" @click="$router.push(`../applybill/draft?id=${projectId}`)">财务请款单</a-button>
            <a-button size="small" icon="form" type="indigo" @click="$router.push(`../progress/draft?id=${projectId}`)">财务进展数据</a-button>
            <a-button size="small" icon="form" type="indigo" @click="$router.push(`../report/draft?id=${projectId}`)">项目报告</a-button>
            <a-button size="small" icon="form" type="indigo" @click="$router.push(`../changeinfo/draft?id=${projectId}`)">项目变更</a-button>
          </template>
        </a-space>
      </template>
    </project-page-header>
    <div class="v-px-md">
      <router-view />
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from './common/page-header'
import { viewPrj } from '@/api/project/house'
export default {
  name: 'HouseProjectView',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
    }
  },
  watch: {
    $route() {
      this.projectId = +this.$route.query.id
    },
    projectId() {
      this.load()
    },
  },
  methods: {
    init() {
      this.projectId = +this.$route.query.id
      this.load()
    },
    load() {
      viewPrj(this.projectId).then(({ data }) => {
        if (data.success) {
          let { state } = data.result
          this.data = data.result
          this.currentStep = state >= 7 ? state - 4 : state
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
